import { Record } from 'immutable';

const TransactionSummarySectionRecord = Record({
    category: '',
    name: '',
    isTotal: false,
    isExpandable: false,
    items: [{ description: '', photo: '', amount: 0.0 }],
    amount: 0.0,
    disclaimer: '',
});

class TransactionSummarySectionModel extends TransactionSummarySectionRecord {}

export default TransactionSummarySectionModel;
